<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { getYear, getFinancialPeriod, amatReportSubmit } from '../../../../api/home.js';
export default {
	name: 'CustomReport',
	data() {
		return {
			zfkmFlag: false,
			kemjb: "3",
			baoblx: ['1'],
			//报表类别
			bblb: getdata().bblb,
			//基本信息
			formlistjbxx: [],
			formdatajbxx: getdata().formdatajbxx
		};
	},
	mounted() {},
	created() {
		
	},
	watch: {
		'formdatajbxx.cains': function(indexVal, oldVal) {
			if(this.formdatajbxx.bblb == "35"){
				this.formdatajbxx.qij = '';
				this.formdatajbxx.qij2 = '';
			}else{
				this.formdatajbxx.qij = '';
				this.GainCwqj(indexVal);
			}
		}
	},
	methods: {
		bblbChange(){
			this.kemjb = "3";
			this.formdatajbxx.cains = "";
			this.formdatajbxx.cains2 = "";
			this.formdatajbxx.qij = "";
			this.formdatajbxx.qij2 = "";
			if(this.formdatajbxx.bblb == ""){
				this.formlistjbxx = [];
			}else if(this.formdatajbxx.bblb == "34" || this.formdatajbxx.bblb == "36" || this.formdatajbxx.bblb == "39"){
				this.formlistjbxx = getdata().formlistjbxx34Or36Or39;
				this.GainNd();
			}else if(this.formdatajbxx.bblb == "35"){
				this.formlistjbxx = getdata().formlistjbxx35;
				this.GainNd();
			}else if(this.formdatajbxx.bblb == "37" || this.formdatajbxx.bblb == "38"){
				this.formlistjbxx = getdata().formlistjbxx37Or38;
				this.GainNd();
			}
			if(this.formdatajbxx.bblb != "36" && this.formdatajbxx.bblb != "38"){
				this.zfkmFlag = true;
			}else{
				this.zfkmFlag = false;
			}
		},
		//通过验证后保存
		getdatajbxx() {
			let params = {};
			params.json = JSON.stringify({ name: this.bblb.find(item => item.value == this.formdatajbxx.bblb).label, taskDesc: 'test', subType: this.formdatajbxx.bblb });
			let param = {};
			param.cains = [];
			param.cains.push(this.formdatajbxx.cains.toString());
			param.cankcn = [];
			param.cankcn.push(this.formdatajbxx.cains2.toString());
			param.qij = [];
			param.qij.push(this.formdatajbxx.qij.toString());
			param.cankqj = [];
			param.cankqj.push(this.formdatajbxx.qij2.toString());
			param.baoblx = this.baoblx;
			if(this.formdatajbxx.bblb != "36" && this.formdatajbxx.bblb != "38" && this.kemjb != "3"){
				param.kemjb = this.kemjb;
			}
			params.param = JSON.stringify(param);
			amatReportSubmit(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('生成成功');
					this.$router.push({
						path: '/ReportTask'
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//生成按钮验证
		generate() {
			let flag = false;
			if(this.formdatajbxx.bblb == "34" || this.formdatajbxx.bblb == "36" || this.formdatajbxx.bblb == "39"){
				if(this.formdatajbxx.cains != "" && this.formdatajbxx.qij != "" && this.formdatajbxx.cains2 != "" && this.formdatajbxx.qij2 != ""){
					flag = true;
				}
			}else if(this.formdatajbxx.bblb == "35"){
				if(this.formdatajbxx.cains != "" && this.formdatajbxx.qij != "" && this.formdatajbxx.qij2 != ""){
					flag = true;
				}
			}else if(this.formdatajbxx.bblb == "37" || this.formdatajbxx.bblb == "38"){
				if(this.formdatajbxx.cains != ""){
					flag = true;
				}
			}else{
				this.$message.error("请选择报表类别！");
				return;
			}
			if(flag){
				this.$refs.taxformjbxx.submitForm();
			}else {
				this.$message.error("基本信息未填写完成！");
			}
		},
		//重置
		empty() {
			this.formdatajbxx = undefined;
			this.formdatajbxx = getdata().formdatajbxx;
			this.formlistjbxx = [];
			this.baoblx = ["1"];
			this.zfkmFlag = false;
		},
		//获取年度
		GainNd() {
			getYear().then(res => {
				this.formdatajbxx.cains = new Date().getFullYear();
				if(this.formdatajbxx.bblb == "34" || this.formdatajbxx.bblb == "36" || this.formdatajbxx.bblb == "39"){
					for (var i = res.data.data.max; i >= res.data.data.min; i--) {
						this.formlistjbxx[0].selectval.push({
							label: i,
							value: i
						});
					}
					this.formlistjbxx[2].selectval = this.formlistjbxx[0].selectval;
				}else if(this.formdatajbxx.bblb == "35"){
					for (var i = res.data.data.max; i >= res.data.data.min; i--) {
						this.formlistjbxx[0].selectval.push({
							label: i,
							value: i
						});
					}
				}else if(this.formdatajbxx.bblb == "37" || this.formdatajbxx.bblb == "38"){
					for (var i = res.data.data.max; i >= res.data.data.min; i--) {
						this.formlistjbxx[0].selectval.push({
							label: i,
							value: i
						});
					}
				}
			});
		},
		//获取财务期间
		GainCwqj(year) {
			let params = {};
			params.year = year;
			getFinancialPeriod(params).then(res => {
				if (this.formdatajbxx.bblb == "34" || this.formdatajbxx.bblb == "36" || this.formdatajbxx.bblb == "39"){
					if (res.data.code == '200') {
						this.formlistjbxx[1].selectval = res.data.data.map(v => {
							return {
								label: v.name,
								value: v.value
							};
						});
						this.formlistjbxx[3].selectval = this.formlistjbxx[1].selectval;
					} else {
						this.formdatajbxx.qij = '';
						this.formlistjbxx[1].selectval = [];
						this.formdatajbxx.qij2 = '';
						this.formlistjbxx[3].selectval = [];
					}
					let currencyMonth = new Date().getMonth() + 1;
					this.formdatajbxx.qij = currencyMonth;
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
